import React from "react";
import FormField from "../form-field/FormField";

interface EditPhoneProps {
  phone: string;
  readonly?: boolean;
}

export default function EditPhone(props: EditPhoneProps) {
  return (
    <FormField
      id="phone"
      labelKey="general.phone"
      component="input"
      className="input"
      fieldName="phone"
      fieldValue={props.phone}
      errorName="phone"
      readOnly={props.readonly}
    />
  );
}
